import React from "react";
import Page from "../../lib/page";
import { Timeline } from 'antd';
import { connect } from 'dva';
import styles from "./index.css";

class AuthorPage extends Page {
    state = {
        curIndex: 0,
        strArr: [
            { name: '订阅分成签约', id: "d1" },
            { name: '千字保底签约', id: "d2" },
            { name: '一键直签计划', id: "d3" }
        ],
        observer: null,
    };

    handleTimelineItemClick = (index) => {
        //console.log('AuthorPage index:', index);
        this.setState({
            curIndex: index,
        });
    }

    componentDidMount() {
        // 创建 Intersection Observer
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // 找到当前可见的元素ID
                    const visibleId = entry.target.id;
                    // 根据ID找到对应的索引
                    const strArr = this.state.strArr;
                    const index = strArr.findIndex(item => item.id === visibleId);
                    if (index !== -1) {
                        this.setState({
                            curIndex: index,
                        });
                    }
                }
            });
        }, {
            threshold: 0.3 // 当元素30%可见时触发
        });

        // 观察所有需要监听的元素
        setTimeout(() => {
            const elementsToObserve = ['d1', 'd2', 'd3'];
            elementsToObserve.forEach(id => {
                const element = document.getElementById(id);
                if (element) {
                    this.observer.observe(element);
                }
            });
        }, 0);
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    render() {
        const { curIndex, strArr, } = this.state;
        const activeColor = "#EAB946";
        const defaultColor = "gray";

        return (
            <div className={styles.wrap}>
                <div className={styles.wrap_top}>
                    <img alt="" src="https://img.cgwrite.cn/qa/up/2508/624503.png" title="长歌中文网，创作无极限" />
                </div>
                <div className={styles.wrap_content}>
                    <div style={{ width: '150px', height: "100%", position: 'relative' }}>
                        <div style={{ width: '150px', position: 'absolute', top: '20%' }}>
                            <Timeline style={{ marginTop: '40px' }}>
                                {strArr.map((item, index) => {
                                    const { name, id } = item
                                    return (
                                        <Timeline.Item
                                            onClick={() => this.handleTimelineItemClick(index)}
                                            color={curIndex == index ? activeColor : defaultColor}
                                            style={{ cursor: 'pointer', fontSize: '16px' }}
                                        >
                                            <a a href={'#' + id}> <span style={{ color: curIndex == index ? activeColor : defaultColor }}>{name}</span> </a>
                                        </Timeline.Item>
                                    )
                                })}
                            </Timeline>
                        </div>
                    </div>
                    <div className={styles.wrap_content_str}>
                        <p style={{ fontSize: '26px', fontWeight: '500', textAlign: 'center' }}>2025长歌中文网作者福利</p>
                        <p style={{ fontSize: '16px', textAlign: 'left' }}>欢迎来到长歌中文网！这是一家致力于挖掘优秀网文作者、努力培养潜力新人作者的新兴原创文学网站！我们用心浇筑梦想，用行动夯实道路，用创作改变人生，长歌中文网将努力为提高优秀作者收入，给更多新人作者赋予创作机会，推出2025作者福利！</p>
                        <p id="d1" style={{ fontSize: '26px', fontWeight: '500', textAlign: 'center' }}>签约计划</p>
                        {/*  */}
                        <p style={{ fontSize: '26px', fontWeight: '500', textAlign: 'center' }}>
                            <span style={{ background: 'yellow' }}>订阅分成签约</span >
                        </p>
                        <p >订阅分成签约细则：</p>
                        <p ><span className={styles.s1}>适用对象：</span>2025年9月1日起，长歌中文网订阅分成签约的作品</p>
                        <p ><span className={styles.s1}>订阅分成：</span>本站净收益50%分成+全渠道净收益50%分成</p>
                        <p ><span className={styles.s1}>版权分成：</span>售出改编权(有声、影视、漫画、出版、短剧（微短剧）、动态漫（漫剧）以及衍生版权等)，网站与作者就版权销售净收益5：5分成，作者分得版权销售净收益的50%</p>
                        <p ><span className={styles.s1}>进阶分成：</span>订阅分成签约的作品，整本书有1次提高分成比例的申请机会</p>
                        <p ><span className={styles.s1}>上架激励奖：</span>签约作品连载更新满20万（含）字后，作品在本站开启VIP入V模式，作品将在本站20章内设置VIP卡点，卡点后的章节需本站付费订阅，作者自动获得上架激励奖600元，上架激励奖经审核通过后，统计并入稿费账单，随稿费于次月15日发放</p>
                        <p ><span className={styles.s1}>上架全勤奖：</span>
                            <table>
                                <thead>
                                    <tr>
                                        <th>全勤档次</th>
                                        <th>每日有效更新字数</th>
                                        <th>全勤奖(元)</th>
                                        <th>奖励时间</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>固定1级</td>
                                        <td>≥2000 字</td>
                                        <td>200</td>
                                        <td>作品全勤首月至第 12 个月</td>
                                    </tr>
                                    <tr>
                                        <td>固定2级</td>
                                        <td>≥4000 字</td>
                                        <td>400</td>
                                        <td>作品全勤首月至第 6 个月</td>
                                    </tr>
                                    <tr>
                                        <td>不固定</td>
                                        <td>2000 字≤4000 字</td>
                                        <td>200或400</td>
                                        <td>作品全勤首月至第 6 个月</td>
                                    </tr>
                                </tbody>
                            </table>
                        </p>
                        <p >获得方式：<br />
                            作品本站上架VIP后的下一个自然月开始计算上架全勤奖，为固定级或不固定，上架入V时由作者和编辑共同确定后，不再更改。每自然月内（每月1日0：00至当月最后一天23：59），每日（0：00~23：59）有效更新字数满足对应全勤档位更新要求，即可获得对应档位全勤奖励
                        </p>
                        <p >发放标准：<br />
                            1.本站成功上架VIP的签约作品<br />
                            2.每月可请假2天<br />
                            3.上架全勤奖为固定级或不固定，上架入V时由作者和编辑共同确定后，不再更改<br />
                            4.如涉及恶意水文、更新无意义内容、使用AIGC生成；或出现章节内容被驳回需修改，在3日内不做修改提交，拒不配合等违规行为，视为自动放弃当月全勤奖<br />
                            5.有效字数统计说明：以作者当天更新的所有正文章节首次通过审核的字数为准。有效字数仅统计一次，以首次统计的有效字数为准。后续任何修改都不影响有效字数（如因此类情况造成全勤更新统计字数不足，作者自行负责）<br />
                        </p>
                        <p >发放时间：<br />
                            上架全勤奖审核通过后，统计并入稿费账单，随稿费于次月15日发放<br />
                        </p>
                        <p ><span className={styles.s1}>完结月激励：</span><br />
                            当作品即将自然完结的当月，称为“完结月”，完结月作品默认发放该作品上一次全勤奖励的50%<br />
                        </p>
                        <p id="d2"><span className={styles.s1}>完结奖：</span><br />
                            作品自然完结，获得完结奖200元，经网站审核通过后，统计并入稿费账单，随稿费于次月15日发放<br />
                            订阅分成签约申请要求：<br />
                            1.作品需首发长歌中文网，作者应拥有所投稿发表作品的全部版权<br />
                            2.申请作品内容不得违反国家相关政策法规，不得含色情、政治、迷信等违禁内容，且必须保证是原创，不得抄袭、高仿、使用AIGC生成<br />
                            3.作者可登陆长歌中文网【创作后台】，创建书籍，字数达到4千字可申请签约，签约审核时间3个工作日内<br />
                            4.对本奖励计划有任何相关疑惑和问题，请联系责编咨询，联系方式请査看网站首页<br />
                            5.本计划内容与签约合同约定不一致的，以签约合同约定为准<br />
                            6.规则调整，计划变更等详情以本网站届时公示信息为准<br />
                        </p>
                        {/*  */}
                        <p style={{ fontSize: '26px', fontWeight: '500', margin: "40px 0 0 0", textAlign: 'center' }}><span style={{ background: 'yellow' }}>千字保底签约</span ></p>
                        <p>长歌中文网愿与作者共担风险，共享收益。在作品成长期，长歌中文网给予作者保底稿费的福利保障，作品进入成熟期超保底后，则按分成模式与作者共享收益。</p>
                        <p>长歌中文网鼓励作者坚持不懈的创作精品内容，持续为优质作品添砖加瓦，鼓励作品在平台内良性竞争，但也严格禁止出现如内容注水、频繁断更、情节混乱、违规侵权等严重违约行为</p>
                        <p >千字保底签约细则：</p>
                        <p ><span className={styles.s1}>适用对象：</span>对自己作品质量有信心/有突出历史成绩/业内有高人气的作者</p>
                        <p ><span className={styles.s1}>收益分成：</span>作品应分收入超保底后，作者可按合同比例获得作品全渠道净收益分成、版权（有声、动漫、影视、游戏、短剧（微短剧）、动态漫（漫剧）、出版等版权及衍生版权等）销售净收益分成</p>
                        <p ><span className={styles.s1}>作品要求：</span>作者应拥有所申请作品的全部版权，作品需至少已完成1万字且有剧情提纲</p>
                        <p ><span className={styles.s1}>实施细则：</span>作者将申请作品发邮件至编辑邮箱</p>
                        <p >邮件格式：</p>
                        <p >邮件标题：《XXXX》(书名)+作品类别+申请保底</p>
                        <p >邮件正文：作者介绍：笔名，联系方式，创作总字数，更新速度，创作经历</p>
                        <p >邮件附件：docx格式的作品正文+提纲</p>
                        <p >收到稿件后，编辑会在3个工作日内进行综合考评并回复结果</p>
                        <p >保底稿酬：每千字50元(税前)起</p>
                        <p style={{ fontWeight: "500", textDecoration: "underline" }}>注意：</p>
                        <p style={{ textDecoration: "underline" }}>完成合同约定月更新字数</p>
                        <p style={{ textDecoration: "underline" }}>无断更、灌水、抄袭等不良记录</p>
                        <p id="d3" style={{ textDecoration: "underline" }}>每月奖励字数不超过30万</p>
                        {/*  */}
                        <p style={{ fontSize: '26px', fontWeight: '500', margin: "40px 0 20px 0", textAlign: 'center' }}><span style={{ background: 'yellow' }}>一键直签计划</span ></p>
                        <p >为自己的作品打Call，给所有作家一个发声的平台</p>
                        <p >一键直签计划细则：</p>
                        <p ><span className={styles.s1}>适用对象：</span>全网作者，网络文学爱好者</p>
                        <p ><span className={styles.s1}>签约标准：</span>作品无抄袭、涉黄、涉政以及其他违规行为，且在长歌中文网平台首发的作品超过四千字后，作家可在网站后台直接申请一键直签，获得纯分成收益</p>
                        <p style={{ textDecoration: "underline" }}><span className={styles.s1}>福利说明：</span>签约作品在自有网站的净收益分成、全渠道净收益分成、以及版权净收益分成将按7:3的比例（作者7网站3）分成发放给作者。一键直签作品不再享有其他福利</p>
                        {/*  */}
                        <p ><span className={styles.s1}>附：投稿说明</span><br />
                            若作品存在抄袭，灌水，恶意断更等行为，或者发现作者为工作室（写同一本书的不止一个人），内容使用AIGC生成，长歌中文网有权扣发所有稿费和福利，并保留追回所有稿酬，福利和其他损失的权利
                        </p>
                        <br />
                    </div>
                </div>
            </div >
        )
    }
}

const state_props = state => {
    return {
    }
}
export default connect(state_props)(AuthorPage);


// WEBPACK FOOTER //
// ./src/layout/authorBenefit/index.js